<template>
  <iframe id="iframe" frameborder="0" :src="url" scrolling="yes" ref="iframe"></iframe>
</template>
<script>
export default {
  data () {
    return {
      url: 'https://ai.hzuht.com/chat/nsgZMrNd2U8IM9Gj'
    }
  }
}
</script>
<style scoped>
iframe {
  display: block; /* iframes are inline by default */
  border: none; /* Reset default border */
  height: 100vh !important; /* Viewport-relative units */
  width: 100vw !important;
}
</style>
